import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M12 9.027a.75.75 0 0 1 0 1.5h-1.833a.75.75 0 0 0-.75.75v7c0 .415.336.75.75.75H20.5a.75.75 0 0 0 .75-.75v-7a.75.75 0 0 0-.75-.75h-1.833l-.077-.004a.75.75 0 0 1 0-1.492l.077-.004H20.5a2.25 2.25 0 0 1 2.25 2.25v7a2.25 2.25 0 0 1-2.25 2.25H10.167a2.25 2.25 0 0 1-2.25-2.25v-7a2.25 2.25 0 0 1 2.25-2.25z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M13.833 3.473a2.25 2.25 0 0 1 2.25 2.25v7a2.25 2.25 0 0 1-2.25 2.25H12a.75.75 0 0 1 0-1.5h1.833a.75.75 0 0 0 .75-.75v-7a.75.75 0 0 0-.75-.75H3.5a.75.75 0 0 0-.75.75v7c0 .414.336.75.75.75h1.833l.077.004a.75.75 0 0 1 0 1.492l-.077.004H3.5a2.25 2.25 0 0 1-2.25-2.25v-7a2.25 2.25 0 0 1 2.25-2.25z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }